<template>
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsRecepcion()">
    <v-form @submit.prevent="submitForm">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="4" v-if="!isNewRecord">
            <v-text-field
              v-model="pago.caja_fecha"
              label="Fecha"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" v-if="!isNewRecord">
            <v-text-field
              v-model="pago.usuario_iniciales"
              label="Usuario"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="pago.turno"
              label="Turno"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="5">
            <SelectTipo
              v-if="isNewRecord"
              v-model="pago.tipo"
              @update:modelValue="onSelectionChange"
            />
            <v-text-field
              v-if="!isNewRecord"
              :model-value="showTipoPagoText(pago.tipo)"
              label="Tipo"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <template v-if="routeSegment == 'C'">
              <v-text-field
                v-model.number="pago.registro"
                label="Registro"
                type="number"
                required
              ></v-text-field>
            </template>
            <template v-if="routeSegment !== 'C' && routeSegment !== 'E'">
              <v-text-field
                v-model.number="pago.registro"
                label="Registro"
                type="number"
                required
                readonly
              ></v-text-field>
            </template>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" v-if="pago.tipo != 6">
            <v-text-field
              :v-if="showByType"
              v-model.number="pago.factura_localizador"
              :label="pago.tipo == 5 ? 'Localizador' : 'Factura'"
              type="string"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="pago.importe"
              label="Importe"
              type="text"
              required
              id="importe"
            ></v-text-field>
          </v-col>
          <v-col v-if="pago.tipo == 6" cols="12" md="4">
            <v-text-field
              v-model="pago.encargo_de"
              :v-if="showByType"
              label="Encargo de"
              maxlength="20"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="pago.detalle"
              label="Detalle"
              rows="3"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn type="submit" color="primary" :loading="loading">
              {{ id < 1 ? 'Actualizar' : 'Crear' }} Pago
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <BaseModal
        v-model="showModal"
        :title="modalConfig.title"
        :message="modalConfig.message"
        :type="modalConfig.type"
        :button-text="modalConfig.buttonText"
      />
    </v-form>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, reactive } from 'vue'
import { usePagosStore } from '@/stores/pagosStore'
import { useVariablesStore } from '@/stores/variablesStore'
import {
  formatDate,
  userIsRecepcion,
  getEnvVariable,
  showTipoPagoText,
  focusFirstInput,
  processImporte
} from '@/utils/helpers'
import { getUser } from '@/utils/tokenStorage'
import NoPermission from '@/components/common/NoPermission.vue'
import SelectTipo from './SelectTipo.vue'
import BaseModal from '../common/BaseModal.vue'
import { useRoute } from 'vue-router'
// import { SELECT_PAGOS } from '@/utils/constants'

const props = defineProps({
  id: {
    type: Number,
    default: null
  }
})
const route = useRoute()
const routeSegment = ref(route.path.split('/').pop().toUpperCase())

// Estado del modal
const showModal = ref(false)
const modalConfig = reactive({
  title: '',
  message: '',
  type: 'info',
  buttonText: 'Aceptar'
})

// const userIsRecepcionValue = userIsRecepcion()
const pagosStore = usePagosStore()
const userIsRecepcionValue = userIsRecepcion()
const variablesStore = useVariablesStore()
const loading = ref(false)
const emit = defineEmits(['saved'])
const nombreRegistro = getEnvVariable('VUE_APP_REGISTRO_PAGO', 'registro_pago')
// Métodos para mostrar modales
// const showError = (message) => {
//   modalConfig.title = 'Error'
//   modalConfig.message = message
//   modalConfig.type = 'error'
//   modalConfig.buttonText = 'Entendido'
//   showModal.value = true
// }

const pago = reactive({
  caja_id: null,
  usuario_id: null,
  turno: null,
  tipo: null,
  hotel: null,
  registro: null,
  detalle: '',
  importe: null,
  factura: null,
  encargo_de: '',
  usuario_iniciales: '',
  caja_fecha: '',
  tipo_detalle: ''
})
const isNewRecord = computed(() => !pago.id)

onMounted(async () => {
  const userInfo = getUser()
  pago.usuario = userInfo.usuario
  pago.usuario_id = userInfo.usuario_id
  pago.hotel = userInfo.hotel
  pago.turno = userInfo.turno
  const data = await pagosStore.getPago(parseInt(props.id))
  pago.numero = data.numero
  if (props.id) {
    loading.value = true
    try {
      Object.assign(pago, data)
      pago.usuario_iniciales = data.usuario_iniciales || ''
      pago.caja_fecha = formatDate(data.caja_fecha) || ''
      pago.caja_id = data.caja_id || null
      // pago.tipo_detalle = showTipoPagoText(item.tipo)
      // usuarios.value = await facturasStore.getUsuarios()
    } catch (error) {
      console.error('Error al cargar la factura:', error)
    } finally {
      loading.value = false
    }
  }
  // Add focus to first enabled input after form is loaded
  focusFirstInput()
})
// const formTitle = computed(() =>
//   props.editIndex === -1 ? 'Nueva Factura' : 'Editar Factura'
// )

const submitForm = async () => {
  // Verificar si el importe es un valor numérico válido
  pago.importe = processImporte(pago.importe)

  loading.value = true
  try {
    if (pago.id) {
      await pagosStore.updatePago(pago)
    } else {
      await pagosStore.createPago({ ...pago })
    }
    emit('saved')
  } catch (error) {
    console.error('Error al guardar el factura:', error)
  } finally {
    loading.value = false
  }
}
defineExpose({
  pago,
  loading,
  // usuarios,
  isNewRecord,
  submitForm,
  userIsRecepcion: () => userIsRecepcionValue
})

const onSelectionChange = (newValue) => {
  if (routeSegment.value !== 'C') {
    getRegistro(newValue)
  }
}

const getRegistro = async (selectedTipo) => {
  // console.log('pago.tipo', selectedTipo)
  try {
    if (parseInt(selectedTipo) > 0) {
      pago.tipo = selectedTipo
      const valorRegistro = parseInt(
        await variablesStore.getValorVariable(
          `${nombreRegistro}_${selectedTipo}`,
          0
        )
      )
      // // console.log('valorRegistro', valorRegistro)
      pago.registro = parseInt(valorRegistro) + 1
    }
  } catch (error) {
    console.error('Error buscando registro:', error)
  }
}

// const handleImporteInput = (event) => {
//   // Check if the value is coming from an event object or directly as a string
//   const inputValue = event && event.target ? event.target.value : event

//   if (inputValue === '' || inputValue === null) {
//     pago.importe = null
//     return
//   }

//   // Replace comma with dot for consistent decimal handling
//   const formattedValue = inputValue.toString().replace(/,/g, '.')
//   console.log('event', event, inputValue, formattedValue)

//   // Only update if it's a valid number
//   if (!isNaN(parseFloat(formattedValue))) {
//     pago.importe = parseFloat(formattedValue)
//   }
// }
</script>
